import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import { DateFormatMAS90 } from '../../functions/dateFormat';
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';



export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {

    }

    selectColor(number) {
        if (number >= 0 && number <= 14) {
            return "status-success"
        } else if (number >= 15 && number <= 29) {
            return "status-warning"
        } else if (number >= 3) {
            return "status-danger"
        }
                
        return ""

}


    render() {
        return (
            <div>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card'>
                                <p className='metric-label'>0-14 Days</p>
                                <div className='metric-value'>{pricesFormat((this.props.Totals.TotalR1/this.props.Totals.TotalDueInv)*100)} %</div>
                                <div className='metric-change status-success'>{NumberFormat(this.props.Totals.Range1)+" / $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR1))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card'>
                                <p className='metric-label'>15-29 Days</p>
                                <div className='metric-value'>{pricesFormat((this.props.Totals.TotalR2/this.props.Totals.TotalDueInv)*100)} %</div>
                                <div className='metric-change status-warning'>{NumberFormat(this.props.Totals.Range2)+" / $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR2))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card'>
                                <p className='metric-label'>+ 30 Days</p>
                                <div className='metric-value'>{pricesFormat((this.props.Totals.TotalR3/this.props.Totals.TotalDueInv)*100)} %</div>
                                <div className='metric-change status-danger'>{NumberFormat(this.props.Totals.Range3)+" / $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR3))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-3 text-center mb-3'>
                            <div className='metric-card'>
                                <p className='metric-label'>Total</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.TotalDueInv))}</div>
                            </div>
                        </div>
                    </div>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-sm-6'>
                                <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                            </div>
                            <div className='pb-3' />
                            <div className="tableFixHeadSmall ">
                                <table className='table table-clean'>
                                    <thead>
                                        <tr>
                                            <th>Invoice No</th>
                                            <th>Customer No</th>
                                            <th>Customer Name</th>
                                            <th>Invoice Due Date</th>
                                            <th>Days Dlq</th>
                                            <th>Current Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.data.map((order, o) => (
                                            <tr className={this.selectColor(Number(order.DaysDlq))} key={o}>
                                                <td>{order.InvoiceNo}</td>
                                                <td>{order.CustomerNo}</td>
                                                <td>{order.CustomerName}</td>
                                                <td className='text-center'>{DateFormatMAS90(order.InvoiceDueDate)}</td>
                                                <td className='text-center'>{order.DaysDlq}</td>
                                                <td className='text-center'>${NumberFormat(pricesFormat(order.Balance))}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
